// Copyright ©️ 2026 eVolve MEP, LLC

import { useEffect, useMemo } from 'react';

import { useCurrentIsolatedSpools } from 'components/Autodesk/extensions/SpoolsExtension/useCurrentIsolatedSpools';
import type { AutodeskDbId } from 'components/Autodesk/types';
import { useAutodeskExtensionStoreActions } from 'components/Autodesk/useAutodeskExtensionStore';
import { hasLengthExactly } from 'helpers/helper-types';

/** Maintains the list of elements eligible for auto-dimensioning */
export const useDimensionableElements = () => {
  // Elements are eligible for auto-dimensioning when a single spool is isolated
  const isolatedSpools = useCurrentIsolatedSpools();
  const dimensionableElements = useMemo<AutodeskDbId[]>(() => {
    if (!hasLengthExactly(isolatedSpools, 1)) return [];
    const [, spool] = isolatedSpools[0];
    return spool.objects.map(({ dbId }) => dbId);
  }, [isolatedSpools]);

  // Update the set of dimensionable elements on change
  const { setDimensionableElements } = useAutodeskExtensionStoreActions('dimensioning');
  useEffect(() => {
    setDimensionableElements(dimensionableElements);
  }, [setDimensionableElements, dimensionableElements]);
};
